
import 'bootstrap'
import logo from '../../recursos/logo2.png'


const NavBarNoLogIn = () => {
  return ( 
    <div >
    <nav className="navbar   navbar-expand-xxl  navbar-light bg-dark">
    <img src={logo} height="75px" width="350" alt="logo" />
    </nav>
 </div>    

  )
}
export default NavBarNoLogIn;